var exports = {
  "I": "HeroSequence__ewvN7g",
};

module.exports = exports;
